import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { ServiceModel } from 'types/api'
import { BaseParams } from 'types/utils'
import { servicesQueryKey } from './useServices'

export function useCreateService() {
  const toast = useToast()
  const { t } = useTranslation('toast')
  const queryClient = useQueryClient()

  async function createService({ body }: BaseParams<ServiceModel, 'POST'>) {
    const response = await apiClient.post(SNA_PREFIX + 'services/', body)
    return response.data
  }

  return useMutation({
    mutationFn: createService,
    onSuccess: () => {
      toast.success({ message: t('serviceCreated') })
      queryClient.invalidateQueries({ queryKey: [...servicesQueryKey] })
    },
    onError: () => {
      toast.error({ message: t('serviceCreateError') })
    }
  })
}
